import type { MisconceptionDefinition } from '../types';

/**
 * TIJD — Kalender sub-registry.
 *
 * Misconcepties rond datumrekenen, dag-van-de-week bepalen, en het
 * oversteken van maand- en jaargrenzen. Het is bewust een kleine
 * sub-registry — kalender is een cognitief eigen domein (modulair
 * rekenen mod 7 voor dagen, ongelijke maandlengtes) en hoort niet
 * thuis bij tijdsduur-rekenen.
 *
 * Families: TIJD-KALENDER.
 *
 * Onderdeel van de TIJD-barrel-splitsing (juni 2026).
 */
export const TIJD_KALENDER_MISCONCEPTIONS: MisconceptionDefinition[] = [{
  id: 'tijd.weekday-off-by-one',
  label: 'Dag van de week off-by-one',
  module: 'Tijd',
  description: 'Leerling telt een dag te veel of te weinig bij het bepalen van een dag-van-de-week (bijv. één dag eerder of later).',
  typicalFamilies: ['TIJD-KALENDER']
}, {
  id: 'tijd.week-same-weekday-missed',
  label: 'Zelfde-dag-bij-veelvoud-van-7 gemist',
  module: 'Tijd',
  description: 'Leerling beseft niet dat n × 7 dagen verder altijd dezelfde dag van de week oplevert.',
  typicalFamilies: ['TIJD-KALENDER']
}, {
  id: 'tijd.month-boundary-not-applied',
  label: 'Maand- of jaargrens niet toegepast',
  module: 'Tijd',
  description: 'Leerling rekent door over de 30/31/28-dagen grens van een maand alsof elke maand even lang is.',
  typicalFamilies: ['TIJD-KALENDER']
}, {
  id: 'tijd.calendar-date-arithmetic-error',
  label: 'Datum-rekenfout',
  module: 'Tijd',
  description: 'Leerling rekent verkeerd met de datum (bijv. 3 + 7 = 9 in plaats van 10, of 17 − 5 = 11 in plaats van 12).',
  typicalFamilies: ['TIJD-KALENDER']
}];